import {useMemo} from 'react';
import dompurify from 'dompurify';

type Sanitizer = typeof dompurify.sanitize;
type DomPurifyData = {
  sanitizer: Sanitizer;
};

export const useDomPurify = (): DomPurifyData => {
  const sanitizer = useMemo(() => dompurify.sanitize, []);

  return {sanitizer};
};

export default useDomPurify;
